/* eslint-disable camelcase */
import { ACTIVE_URL } from 'aurora-utils/constants';

const { BASE_URL } = ACTIVE_URL;

const v1 = 'v1';
const rootUrl = `/dotnet/api/${v1}`;

const DOTNET_MODULES = {
  LOOKUP: `${rootUrl}/lookup`,
  APPLICATION: `${rootUrl}/application`,
  UPDATE_CUSTOMER: `${rootUrl}/update-customer-data`,
  PAYMENT: `${rootUrl}/payment`,
};

const GENERAL = {
  ROOT_URL: rootUrl,
};

const WORKFLOW = {
  FETCH_APPLICATION: `${DOTNET_MODULES.APPLICATION}`,
  PRE_VALIDATE: `${DOTNET_MODULES.APPLICATION}/pre-validation`,
  INITIATE_APPLICATION: `${DOTNET_MODULES.APPLICATION}/initiate`,
  CHECKOUT_APPLICATION: `${DOTNET_MODULES.APPLICATION}/checkout`,
};

const CONTRACTS = {
  FETCH_INDIVIDUAL_CONTRACT_DETAIL: `${rootUrl}/interpersonal-musataha/musataha-between-individual-contract-details`,
};

const LOOKUP = {
  LOCAL_EXHIBITION_NAMES: `${DOTNET_MODULES.LOOKUP}/local-exhibition`,
  FORGEIGN_EXHIBITION_NAMES: `${DOTNET_MODULES.LOOKUP}/foreign-exhibition`,
  NATIONALITIES: `${DOTNET_MODULES.LOOKUP}/GetNationality`,
  SURVEYING_EMPLOYEE: `${DOTNET_MODULES.LOOKUP}/surveying-employee`,
  SURVEYING_COMPANY: `${DOTNET_MODULES.LOOKUP}/surveying-company`,
};

const DOCUMENT = {
  DELETE_DOCUMENT: `${rootUrl}/document`, // DELETE
  DOWNLOAD_DOCUMENT: `${rootUrl}/document/download`,
};
const PROFESSION_REGISTRATION = {
  ROOT_URL: rootUrl,
  FETCH_PROFESSIONS_TYPES: `${DOTNET_MODULES.LOOKUP}/profession-type`,
  FETCH_PROFESSIONS_TYPE_CLASSIFICATION: `${DOTNET_MODULES.LOOKUP}/profession-classification`,
  INITIATE_APPLICATION: `${DOTNET_MODULES.APPLICATION}/initiate`,
  UPDATE_CUSTOMER_DATA: `${DOTNET_MODULES.UPDATE_CUSTOMER}/save`,
  FETCH_APPLICATION: `${DOTNET_MODULES.APPLICATION}`,
  UPLOAD_CUSTOMER_DOCUMENT: `${DOTNET_MODULES.UPDATE_CUSTOMER}/document/upload`,
  FETCH_CUSTOMER_DOCUMENT: `${DOTNET_MODULES.UPDATE_CUSTOMER}/document/fetch`,
  DOWNLOAD_CUSTOMER_DOCUMENT: `${rootUrl}/document/download`,
  CHECKOUT: `${DOTNET_MODULES.APPLICATION}/checkout`,
  DOWNLOAD_LICENSE: `${DOTNET_MODULES.APPLICATION}`,
  LICENSE_PAYMENT_BREAKDOWN: `${DOTNET_MODULES.PAYMENT}/license`,
  VALIDATE_THINKPROP: `${rootUrl}/update-customer-data/ValidateThinkPropbyEID`,
  LICENSE_PAYMENT_SUCCESS: `${DOTNET_MODULES.PAYMENT}/license/success`,
};

const PERMITS = {
  EVENT_LAUNCH_PERMIT: `${rootUrl}/event-launch-permit/save`,
  LOCAL_EXHIBITION_PERMIT: `${rootUrl}/local-exhibition-permit/save`,
  INTERNATIONAL_EXHIBITION_PERMIT: `${rootUrl}/international-exhibition-permit/save`,
  DOWNLOAD_EVENT_LAUNCH_QR_CODE: `${rootUrl}/event-launch-permit/Downloadqrcode`,
  DOWNLOAD_LOCAL_EXHIBITION_QR_CODE: `${rootUrl}/event-launch-permit/Downloadqrcode`,
  GET_COUNTRIES_LIST: `${rootUrl}/international-exhibition-permit/GetNationality`,
  GET_EXHIBITIONS: `${rootUrl}/international-exhibition-permit/GetExhibition`,
};
const CERTIFICATE = {
  APPLICATION_DETAILS: `${rootUrl}/application/pma-registration`,
  VALUATION_LAND_SAVE_APPLICATION: `${rootUrl}/land-valuation-certificate/save`,
  VALUATION_UNIT_SAVE_APPLICATION: `${rootUrl}/unit-valuation-certificate/save`,
  CHECKOUT_APPLICATION: `${rootUrl}/application/checkout`,
  EVALUATION_REASONS: `${DOTNET_MODULES.LOOKUP}/property-valuation`,
  VALUATION_CERTIFICATE_PAYMENT_BREAKDOWN: `${DOTNET_MODULES.PAYMENT}/valuation`,
  UPLOAD_DOCUMENT: `${rootUrl}/valuation-certificate/upload`,
  DOWNLOAD_CERTIFICATE_VALUATION_LAND: `${rootUrl}/land-valuation-certificate/Downloadcertificate`,
  DOWNLOAD_CERTIFICATE_VALUATION_UNIT: `${rootUrl}/unit-valuation-certificate/Downloadcertificate`,
};
const MUSATAHA_REGISTRATION = {
  PERMISSIONS: `${rootUrl}/interpersonal-musataha/permissions`,
  UPLOAD_DOCUMENT: `${rootUrl}/interpersonal-musataha/upload`,
  CALCULATE_FEES: `${rootUrl}/interperosnal-musatah/calculate`,
  FETCH_FEES: `${rootUrl}/payment/interperosnal-musatah`,
  SAVE_APPLICATION: `${rootUrl}/interpersonal-musataha/save`,
  OWNER_APPROVAL: `${rootUrl}/interpersonal-musataha/owner-approval`,
  OWNER_RETURN: `${rootUrl}/interpersonal-musataha/owner-return`,
  MUSATAHA_APPROVAL: `${rootUrl}/interpersonal-musataha/musateh-approval`,
  MUSATAHA_RETURN: `${rootUrl}/interpersonal-musataha/musateh-return`,
  ADD_MUSATEH: `${rootUrl}/interpersonal-musataha/add-musataha`,
  DELETE_MUSATEH: `${rootUrl}/interpersonal-musataha/delete-musataha`,
  UPDATE_MUSATEH: `${rootUrl}/interpersonal-musataha/update-musataha`,
  DOWNLOAD_CERTIFICATE_MUSATAHA: `${rootUrl}/interpersonal-musataha/complete`,
  DOWNLOAD_INDIVIDUAL_CONTRACT: `${rootUrl}/interpersonal-musataha/download-contract`,
};
export {
  BASE_URL,
  PROFESSION_REGISTRATION,
  WORKFLOW,
  PERMITS,
  CERTIFICATE,
  DOCUMENT,
  GENERAL,
  LOOKUP,
  MUSATAHA_REGISTRATION,
  CONTRACTS,
};
